import axios from "axios";
import { Component } from "react";
import { PRODUCTMEDIA } from "../../constants/const";
import "./styles.css"


export default class ProductItemCard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            media: null
        }
    }

    fixDate = (date) => {
        if (date) {
            let year = date.slice(0, 4)
            let month = date.slice(4, 6)
            let day = date.slice(6, 8)
            var returnDate = new Date(year, month, day).toLocaleDateString('da-DK', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            })
            return returnDate
        }

    }

    componentDidMount() {
        let imageId = this.props.product.acf.mynd
        let url = PRODUCTMEDIA
        // console.log(imageId)

        if (imageId) {
            axios
                .get(url + imageId)
                .then((res) => {
                    this.setState({ media: res.data.guid.rendered })
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }


    render() {
        var productTitle = this.props.product.title.rendered
        var productUndertitle = this.props.product.acf.undirtitill
        var shortDescription = this.props.product.acf.stutt_lysing
        var productDate = ""

        const productImageStyle = {
            background: 'url(' + this.state.media + ')'
        }

        if (this.props.product.acf.dags_texti === "") {
            let date = this.props.product.acf.dags
            productDate = this.fixDate(date)

        }
        else {
            productDate = this.props.product.acf.dags_texti
        }

        return (
            <a href={this.props.product.link}>

            <div className="card">
                <div className="item-card-content">
                    
                        {/* Image */}
                        {/* <img src={productImage} /> */}
                        <div className="item-card-image" 
                            style={productImageStyle} >

                        </div>

                        <div className="item-card-text">
                            {/* * Title */}
                            <p className="item-card-title">
                                {productTitle}
                            </p>
                            {/* * Sub Title */}
                            <p className="item-card-subtitle">
                                {productUndertitle}
                            </p>
                            {/* * Date / Text */}
                            <p className="item-card-date">
                                {productDate}
                            </p>
                            {/* * Text */}
                            <p className="item-card-description">
                                {shortDescription}
                            </p>
                        </div>
                </div>
            </div>
            </a>

        )
    }
}